import { useMemo } from 'react';
import { Button, Result, Spin, Tabs, Typography } from 'antd';
import {
  AppstoreOutlined, EnvironmentOutlined, KeyOutlined,
  PlayCircleOutlined, SafetyOutlined, TeamOutlined,
} from '@ant-design/icons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCurrentUser } from '@/common/auth/adminAcl';
import PermissionTab from './PermissionTab';
import RoleTab from './RoleTab';
import SceneCategoryTab from './SceneCategoryTab';
import ScenePreviewTab from './ScenePreviewTab';
import TaskTypeTab from './TaskTypeTab';
import UserTab from './UserTab';

const { Title } = Typography;

export default function AdminPage() {
  const navigate = useNavigate();
  const { isAdmin, loading } = useCurrentUser();
  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey = searchParams.get('tab') || 'user';

  const items = useMemo(
    () => [
      {
        key: 'user',
        label: <span><TeamOutlined /> 用户管理</span>,
        children: <UserTab />,
      },
      {
        key: 'role',
        label: <span><SafetyOutlined /> 角色管理</span>,
        children: <RoleTab />,
      },
      {
        key: 'permission',
        label: <span><KeyOutlined /> 权限点</span>,
        children: <PermissionTab />,
      },
      {
        // 场景类型:放在任务类型前面 —— 场景先分类,再决定跑哪些任务
        key: 'scene-category',
        label: <span><EnvironmentOutlined /> 场景类型</span>,
        children: <SceneCategoryTab />,
      },
      {
        key: 'task-type',
        label: <span><AppstoreOutlined /> 任务类型</span>,
        children: <TaskTypeTab />,
      },
      {
        key: 'scene-preview',
        label: <span><PlayCircleOutlined /> 场景预览</span>,
        children: <ScenePreviewTab />,
      },
    ],
    [],
  );

  const onChange = (key: string) => {
    setSearchParams({ tab: key }, { replace: true });
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Spin />
      </div>
    );
  }

  if (!isAdmin) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Result
          status="403"
          title="无权限访问"
          subTitle="后台管理仅对持有 admin 角色或 menu:admin 权限的成员开放，如需开通请联系管理员。"
          extra={
            <Button type="primary" onClick={() => navigate('/', { replace: true })}>
              返回首页
            </Button>
          }
        />
      </div>
    );
  }

  return (
    <div style={{ padding: 16, background: '#fff', minHeight: '100%' }}>
      <Title level={4} style={{ marginTop: 0 }}>后台管理</Title>
      <Tabs activeKey={activeKey} onChange={onChange} items={items} destroyOnHidden />
    </div>
  );
}
